module.exports = __webpack_public_path__ + "static/school_obj7@2x-8834904b4aeb3737e183b52c77beb9d7.png";